import { render, staticRenderFns } from "./OrdersEdit.vue?vue&type=template&id=5012e513"
import script from "./OrdersEdit.vue?vue&type=script&lang=ts"
export * from "./OrdersEdit.vue?vue&type=script&lang=ts"
import style0 from "./OrdersEdit.vue?vue&type=style&index=0&id=5012e513&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports